import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges, ViewChild, AfterViewInit } from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-hp-grid',
  templateUrl: './hp-grid.component.html',
  styleUrls: ['./hp-grid.component.scss']
})
export class HpGridComponent implements OnInit, OnChanges, AfterViewInit {


  @ViewChild('grid') grid: GridComponent;
  @Input() hpData: any;
  @Input() dataUpdatedV: boolean;
  @Input() showEdit: boolean;
  // @Input() hpData = [];
  @Output() editRecord = new EventEmitter<string>();
  @Output() deleteRecord = new EventEmitter<string>();

  hspColumnsArray = [

    {
      'name': '',
      'keyValue': '',
      'total': ''
    },
    {
      'name': 'Non-Special Needs',
      'keyValue': '',
      'total': ''
    },
    {
      'name': 'Individuals',
      'keyValue': 'noSpecIndividuals',
      'total': 0
    },
    {
      'name': 'Family',
      'keyValue': 'noSpecFamily',
      'total': 0
    },

    {
      'name': 'Senior',
      'keyValue': 'noSpecSenior',
      'total': 0
    },
    {
      'name': 'Veterans',
      'keyValue': 'noSpecVeterans',
      'total': 0
    },
    {
      'name': 'Market Rate',
      'keyValue': 'marketRate',
      'total': 0
    },
    {
      'name': 'Manager',
      'keyValue': 'manager',
      'total': 0
    },
    {
      'name': 'Non-Special Needs Sub Total',
      'keyValue': 'nonSpecialNeedsTotalSite',
      'total': 0
    },
    {
      'name': 'SN-Non-Homeless',
      'keyValue': '',
      'total': ''
    },
    {
      'name': 'Intellectual/Developmental Disabilities',
      'keyValue': 'noHomeDisabled',
      'total': 0
    },
    {
      'name': 'Transition Age Youth (TAY)',
      'keyValue': 'nhTransitionYouth',
      'total': 0
    },
    {
      'name': 'Chronic Illness (HIV/ AIDS)',
      'keyValue': 'nhChronicIllness',
      'total': 0
    },
    {
      'name': 'SN-Non-Homeless Sub Total',
      'keyValue': 'nonHomelessTotalSite',
      'total': 0
    },
    {
      'name': 'SN-Homeless',
      'keyValue': '',
      'total': ''
    },
    {
      'name': 'Mental Illness',
      'keyValue': 'mentalIllness',
      'total': 0
    },
    {
      'name': 'Chronic Illness (HIV/ AIDS)',
      'keyValue': 'hChronicIllness',
      'total': 0
    },
    {
      'name': 'Transition Age Youth (TAY)',
      'keyValue': 'hTransitionAgeYouth',
      'total': 0
    },
    {
      'name': 'Intellectual/Developmental Disabilities',
      'keyValue': 'hIntellectualDevelopmentalDisabilities',
      'total': 0
    },
    {
      'name': 'Chronically Homeless',
      'keyValue': 'hChronicallyHomeless',
      'total': 0
    },
    {
      'name': 'Veterans',
      'keyValue': 'homelessVeterans',
      'total': 0
    },
    {
      'name': 'Seniors',
      'keyValue': 'hSeniors',
      'total': 0
    },
    {
      'name': 'Survivors of Domestic Violence',
      'keyValue': 'hSurvivorsOfDomesticViolence',
      'total': 0
    },
    {
      'name': 'Survivors of Human Trafficking',
      'keyValue': 'hSurvivorsOfHumanTrafficking',
      'total': 0
    },
    {
      'name': 'Family',
      'keyValue': 'homelessFamily',
      'total': 0
    },
    {
      'name': 'Individuals',
      'keyValue': 'homelessIndividuals',
      'total': 0
    },
    {
      'name': 'SN-Homeless Sub Total',
      'keyValue': 'homelessTotalSite',
      'total': 0
    },
    {
      'name': '',
      'keyValue': '',
      'total': ''
    },
    {
      'name': 'Total',
      'keyValue': 'totalTargetSite',
      'total': ''
    }
  ];

  constructor() { }

  ngOnInit() {

    this.UpdateTotals();
    setTimeout(() => {
            this.fixGridAccessibility();
          }, 100);
  }

  ngAfterViewInit() {
      // Ensure Kendo grid content role is corrected on render and later updates.
      this.fixGridAccessibility();
      
  }

  ngOnChanges(changes: SimpleChanges) {

    // console.log(this.dataUpdatedV)
    if (this.dataUpdatedV) {
      this.UpdateTotals();
    }
  }

  UpdateTotals() {
    if(this.hpData === undefined){
      this.hpData = [];
    }
    this.hpData.forEach((element, index) => {
      for (const key in element) {
        if (key !== '') {
          const totalRef = this.hspColumnsArray.find(x => x.keyValue === key);
          if (totalRef !== undefined) {
            if (index === 0) {
              this.hspColumnsArray.find(x => x.keyValue === key).total = 0;
            }
            this.hspColumnsArray.find(x => x.keyValue === key).total = totalRef.total + element[key];

            
          }
          setTimeout(() => {
            this.fixGridAccessibility();
          }, 100);
        }
      }
    });

    
  }

  editRecordFn(site) {
    this.editRecord.emit(site);
  }

  deleteRecordFn(site) {
    this.deleteRecord.emit(site);
  }

   private fixGridAccessibility() {
  setTimeout(() => {
    if (this.grid) {
      const wrapper = this.grid.wrapper.nativeElement;

      // FIX ISSUE 1: Neutralize all table elements within the grid root
      // This stops Axe from seeing <table> as an invalid child of role="grid"
      const tables = wrapper.querySelectorAll('table');
      tables.forEach(table => {
        table.setAttribute('role', 'presentation');
      });

      // FIX ISSUE 2: Ensure the hierarchy is rowgroup -> row -> gridcell
      const gridContent = wrapper.querySelector('.k-grid-content');
      if (gridContent) {
        gridContent.setAttribute('role', 'rowgroup');

        // Find all table rows within the content area
        const rows = gridContent.querySelectorAll('tr');
        rows.forEach(row => {
          // Kendo sometimes misses the 'row' role on these internal <tr> elements
          // Adding it satisfies the requirement that gridcells must be inside a row
          row.setAttribute('role', 'row');
        });

        // Setup MutationObserver to maintain these roles during scrolling/virtualization
        const observer = new MutationObserver(() => {
          const currentRows = gridContent.querySelectorAll('tr');
          currentRows.forEach(row => {
            if (row.getAttribute('role') !== 'row') {
              row.setAttribute('role', 'row');
            }
          });
        });

        observer.observe(gridContent, {
          childList: true,
          subtree: true
        });
      }

      // Handle the Locked Columns section (common in Kendo)
      const lockedContent = wrapper.querySelector('.k-grid-content-locked');
      if (lockedContent) {
        lockedContent.setAttribute('role', 'rowgroup');
        lockedContent.querySelectorAll('tr').forEach(row => row.setAttribute('role', 'row'));
      }

      // Ensure Header follows the same rules
      const headerRows = wrapper.querySelectorAll('.k-grid-header tr');
      headerRows.forEach(row => row.setAttribute('role', 'row'));
    }
  }, 200);
}



}
